import type {NormalizedSignoffDataType} from 'app/signoffs/types';
import type {
  SignoffDocumentSerializedType,
  SignoffSerializedType,
} from 'sweet-types';

export function normalizeSignoffData(
  signoff: SignoffSerializedType | SignoffDocumentSerializedType
): NormalizedSignoffDataType {
  return {
    documentName: signoff.name,
    documentContentType: signoff.content_type,
    user: signoff.user,
    signedAt: signoff.signed_at,
    can_export: signoff.can_export,
    ...('id' in signoff
      ? {
          signoffId: signoff.id,
          signedVersionIsCurrent:
            signoff.version_content_object?.is_current ?? null,
          signedVersionHTMLURL:
            signoff.version_content_object?.html_url ?? null,
          signedVersionApprovedAt:
            signoff.version_content_object?.approved_at ?? null,
          lastRequestSentAt: signoff.last_request_sent_at,
          isSignedOff: signoff.signed_at != null,
        }
      : {
          signoffId: signoff.signoff_id,
          signedVersionIsCurrent: signoff.signed_version_is_current,
          signedVersionHTMLURL: signoff.signed_version_html_url,
          signedVersionApprovedAt: signoff.signed_version_approved_at,
          lastRequestSentAt: signoff.current_last_request_sent_at,
          isSignedOff:
            signoff.signed_at != null &&
            signoff.current_created_at < signoff.signed_at,
        }),
  };
}
